export default __webpack_public_path__ + "static/banner-md-a5577e3b1eaf9c70334b42a1e852592a.png";